import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  email: Yup.string().required("Required").email("Enter a valid email"),
  name: Yup.string().required("Required"),
  // phone: Yup.number().typeError("Enter a valid number").required("Required"),
});
